var _circle, _path, _path2, _ellipse, _ellipse2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const Svg1F600 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#FFCC4D",
    cx: 18,
    cy: 18,
    r: 18
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#664500",
    d: "M18 21c-3.623 0-6.027-.422-9-1-.679-.131-2 0-2 2 0 4 4.595 9 11 9 6.404 0 11-5 11-9 0-2-1.321-2.132-2-2-2.973.578-5.377 1-9 1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M9 22s3 1 9 1 9-1 9-1-2 4-9 4-9-4-9-4z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    fill: "#664500",
    cx: 12,
    cy: 13.5,
    rx: 2.5,
    ry: 3.5
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    fill: "#664500",
    cx: 24,
    cy: 13.5,
    rx: 2.5,
    ry: 3.5
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(Svg1F600);
export { ForwardRef as ReactComponent };
export default "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\"><circle fill=\"#FFCC4D\" cx=\"18\" cy=\"18\" r=\"18\"></circle><path fill=\"#664500\" d=\"M18 21c-3.623 0-6.027-.422-9-1-.679-.131-2 0-2 2 0 4 4.595 9 11 9 6.404 0 11-5 11-9 0-2-1.321-2.132-2-2-2.973.578-5.377 1-9 1z\"></path><path fill=\"#FFF\" d=\"M9 22s3 1 9 1 9-1 9-1-2 4-9 4-9-4-9-4z\"></path><ellipse fill=\"#664500\" cx=\"12\" cy=\"13.5\" rx=\"2.5\" ry=\"3.5\"></ellipse><ellipse fill=\"#664500\" cx=\"24\" cy=\"13.5\" rx=\"2.5\" ry=\"3.5\"></ellipse></svg>";